<template>
  <div>
    <Modal aria="false" :style-class="visible ? 'display: block;' : 'display: none;'">
      <template v-slot:content>
        <div class="container_content">
          <img src="@/assets/warning.svg" alt="">
          <p class="container_title">
            Are you sure you want to {{ merchantToUpdate.type === 'block' ? 'block' : 'unblock' }}
            <span>{{ merchantToUpdate.merchant.fullname }}?</span>
          </p>
          <div class="btns">
            <div class="close_btn" @click="closeModal">Cancel</div>
            <div class="confirm_btn" :class="{ loading: loading }" @click="!loading ? confirmUpdate() : null">
              Confirm
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/modalv2.vue";

export default {
  name: "ExtendModal",

  components: {
    Modal,
  },

  props: {
    merchantToUpdate: {
      type: Object,
      required: true,
    },
  },

  computed: {
    visible() {
      return !!this.merchantToUpdate;
    },
  },

  watch: {
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          const modalElement = document.querySelector('.modal');
          if (modalElement) {
            modalElement.classList.add('show');
            modalElement.style.display = 'block';
          }
        });
      }
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  methods: {
    closeModal() {
      this.$emit("hide");
    },
    confirmUpdate() {
      this.$emit("confirmed", this.merchantToUpdate);
    },
  },
};
</script>

<style lang="scss">
.container_content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
}

.btns {
  display: flex;
  align-items: center;
  gap: 32px;
  width: 100%;
  justify-content: space-between;
}

.confirm_btn,
.close_btn {
  font-family: Lato;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  text-align: center;
  background-color: #e00b5b;
  border-radius: 6px;
  border-style: none;
  box-sizing: border-box;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  height: 48px;
  width: 100%;
}

.close_btn {
  color: black !important;
  background-color: white !important;
  border: 1px solid #848688;
  color: #848688 !important;
}

.modal-content {
  border-radius: 16px !important;
  max-width: 700px !important;
  padding-left: 5% !important;
  padding-right: 5% !important;
}

.container_title {
  font-size: 30px;
  font-weight: 600;
  text-align: center;

  span {
    color: #e00b5b;
  }
}

.loading {
  opacity: 0.5;
}
</style>
